import React from "react";
import { makeStyles } from "tss-react/mui";
import { withPixelLineHeight } from "../../../base/styles/functions.web";
// @ts-ignore
import { VideoQualityLabel } from "../../../video-quality/components";
const useStyles = makeStyles()((theme) => {
    return {
        timerContainer: {
            position: "absolute",
            right: "1px",
            top: "34px",
            background: "#000",
            padding: "6px 20px",
            display: "flex",
            "@media (max-width: 1024px)": {
                background: "rgba(0, 0, 0, 0.6)",
                right: "-20px",
                top: "39px",
                padding: "1px 0px",
            }
        },
        timer: {
            ...withPixelLineHeight(theme.typography.labelRegular),
            color: theme.palette.text01,
            padding: "6px 8px",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            boxSizing: "border-box",
            height: "28px",
            borderRadius: `0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0`,
            marginRight: "2px",
            "@media (max-width: 300px)": {
                display: "none",
            },
            "@media (max-width: 500px)": {
                backgroundColor: "transparent"
            }
        },
    };
});
/**
 * Returns web element to be rendered.
 *
 * @returns {ReactElement}
 */
export default function ConferenceTimerDisplay({ timerValue, textStyle: _textStyle, }) {
    const { classes } = useStyles();
    return (React.createElement("div", { className: classes.timerContainer },
        React.createElement("span", { className: classes.timer }, timerValue),
        React.createElement("div", null,
            React.createElement(VideoQualityLabel, null))));
}
